var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFallbackPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ADB5BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9037 16H18.0954C17.4901 16 17 16.5674 17 17.2668V27.6506C17 28.148 17.2522 28.6003 17.6443 28.8054L23.538 31.8874C23.8254 32.0375 24.1537 32.0375 24.4411 31.8874L30.3557 28.7944C30.7478 28.5893 31 28.138 31 27.6396V17.2668C31 16.5674 30.5099 16 29.9046 16H29.9037ZM24.2098 30.9878C24.0795 31.0559 23.9272 31.0559 23.7968 30.9878L18.1725 28.0569C18.0135 27.9739 17.9127 27.8037 17.9127 27.6166V24.8518L26.925 29.5649L24.2098 30.9868V30.9878ZM30.0864 22.2381L27.5197 20.9032V19.9336C27.5197 19.7975 27.4151 19.6874 27.2866 19.6874H20.6268C20.5469 19.6874 20.4812 19.7565 20.4812 19.8405V19.8465C20.4812 19.9056 20.5126 19.9586 20.563 19.9846L30.0864 24.9189V27.4845C30.0864 27.6887 29.9046 27.8248 29.7438 27.7417L17.9127 21.6427V17.452C17.9127 17.1808 18.1211 16.9606 18.378 16.9606H29.6201C29.877 16.9606 30.0854 17.1808 30.0854 17.452V22.2381H30.0864Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallbackPlaceholder);
export default __webpack_public_path__ + "static/media/fallbackPlaceholder.fa74c29546a5537d0f33223e6c454ad3.svg";
export { ForwardRef as ReactComponent };